module.exports = __webpack_public_path__ + "bf8c6c2093b06e75f1d419da38a22fd4.fbx";